import { render, staticRenderFns } from "./MenuPartner.vue?vue&type=template&id=125f5514&scoped=true&"
import script from "./MenuPartner.vue?vue&type=script&lang=js&"
export * from "./MenuPartner.vue?vue&type=script&lang=js&"
import style0 from "./MenuPartner.vue?vue&type=style&index=0&id=125f5514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f5514",
  null
  
)

export default component.exports